import styled from 'styled-components'
import { getDashColor } from '../../styles'

export const Card = styled.div`
  background: #f7f9fc;
  border: 1px solid #e6ebf3;
  border-radius: 12px;
  padding: 20px 24px;
  max-width: 620px;
  margin-top: 8px;
  @media (max-width: 768px) {
    max-width: 100%;
    padding: 16px;
  }
`

export const StatementRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 6px 0;
  font-size: 14px;
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-variant-numeric: tabular-nums;
`

export const StatementLabel = styled.span`
  font-weight: 500;
  small {
    display: block;
    color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
    opacity: 0.7;
    font-size: 12px;
  }
`

export const StatementValue = styled.span<{ negative?: boolean }>`
  font-weight: 700;
  white-space: nowrap;
  color: ${({ negative }) =>
    negative ? '#b3231f' : 'inherit'};
`

export const StatementTotal = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border-top: 1.5px solid ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  margin-top: 6px;
  padding-top: 10px;
  font-weight: 800;
  font-size: 14px;
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-variant-numeric: tabular-nums;
`

export const Breakdown = styled.details`
  margin: 4px 0;
  summary {
    cursor: pointer;
    font-size: 13px;
    font-weight: 700;
    color: #b3231f;
    list-style: none;
    padding: 2px 0;
  }
  summary::-webkit-details-marker {
    display: none;
  }
`

export const BreakdownList = styled.div`
  border-left: 3px solid #e6ebf3;
  margin: 6px 0;
  padding-left: 14px;
`

export const CoverageHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  margin-top: 18px;
  font-size: 14px;
  strong {
    color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  }
  span {
    font-size: 12px;
    color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
    opacity: 0.8;
    font-variant-numeric: tabular-nums;
  }
`

export const CoverageBar = styled.div`
  height: 8px;
  border-radius: 100px;
  background: #e2e8f2;
  margin: 10px 0;
  overflow: hidden;
`

export const CoverageFill = styled.div<{ percentage: number }>`
  height: 100%;
  min-width: 12px;
  width: ${({ percentage }) => percentage}%;
  border-radius: 100px;
  background: ${getDashColor('PRIMARY_BLUE_02', 'SECONDARY_COLOR')};
`

export const CoverageNote = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  opacity: 0.85;
  b {
    color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
    font-variant-numeric: tabular-nums;
  }
`
